import { EXPEDITED_PROGRAM } from "./expeditedProgramKey.constants";

export const FILL_IN_TABLE_KEY = {
  ClinicalTrials: "Clinical Trials",
  ClinicalTrialStatus: "Clinical Trial Status",
  CompanyWebsiteVariousPages: "Company Website Various Pages",
  Regulatory: "Regulatory",
  Deals: "Deals",
  DealLaSc: "Deal LA&SC",
  ExpeditedProgram: EXPEDITED_PROGRAM,
  VentureCapital: "Venture Capital",
  Publication: "Publication",
  PublicationJournal: "Publication Journal",
  ConferenceSchedule: "Conference Schedule",
  DealFiling: "Deal Filing",
  FundingFiling: "Funding Filing",
  CTG: "CTG",
} as const;
